// extracted by mini-css-extract-plugin
export default {"pickerContainer":"bt-color-picker_pickerContainer__oWgqc","translated":"bt-color-picker_translated__dgaFP"};